import { useState, useEffect } from 'react'
import { supabase } from './supabase'

export default function MatchSchedule({ session, onCreateMatch, onOpenLobby, onOpenTable }) {
  const [upcoming, setUpcoming] = useState([])
  const [past, setPast] = useState([])
  const [unscheduled, setUnscheduled] = useState([])
  const [profiles, setProfiles] = useState({})
  const [loading, setLoading] = useState(true)
  const [showPast, setShowPast] = useState(false)

  useEffect(() => { fetchMatches() }, [session])

  const fetchMatches = async () => {
    setLoading(true)

    // Golf matches
    const { data: created } = await supabase.from('matches').select('*').eq('creator_id', session.user.id).neq('state', 'archived')
    const { data: joined } = await supabase.from('match_players').select('match_id').eq('player_id', session.user.id).eq('status', 'accepted')
    let joinedMatches = []
    if (joined && joined.length > 0) {
      const ids = joined.map(j => j.match_id)
      const { data: jm } = await supabase.from('matches').select('*').in('id', ids).neq('state', 'archived')
      joinedMatches = jm || []
    }
    const allMatches = [...(created || []), ...joinedMatches.filter(m => !(created || []).find(c => c.id === m.id))]
    const matchItems = allMatches.map(m => ({ ...m, _type: 'match', _date: m.tee_time }))

    // 1v1 bets with event date
    const { data: ovo } = await supabase.from('one_v_one').select('*')
      .or(`created_by.eq.${session.user.id},opponent_id.eq.${session.user.id}`)
      .in('status', ['active', 'claimed', 'disputed'])
      .not('settle_by', 'is', null)
    const ovoItems = (ovo || []).map(b => ({ ...b, _type: '1v1', _date: b.settle_by }))

    // Tables with scheduled date
    const { data: myTables } = await supabase.from('crossbet_table_players').select('table_id').eq('player_id', session.user.id).eq('status', 'accepted')
    let tableItems = []
    if (myTables && myTables.length > 0) {
      const tids = myTables.map(t => t.table_id)
      const { data: tables } = await supabase.from('crossbet_tables').select('*').in('id', tids).in('status', ['pending', 'active']).not('scheduled_at', 'is', null)
      tableItems = (tables || []).map(t => ({ ...t, _type: 'table', _date: t.scheduled_at }))
    }

    // Load profiles for 1v1 opponents
    const ovoIds = [...new Set((ovo || []).flatMap(b => [b.created_by, b.opponent_id]))]
    if (ovoIds.length > 0) {
      const { data: prof } = await supabase.from('profiles').select('id, first_name, last_name').in('id', ovoIds)
      const pmap = {}
      prof?.forEach(p => { pmap[p.id] = p })
      setProfiles(pmap)
    }

    console.log('ovoItems:', ovoItems)
    console.log('all items:', [...matchItems, ...ovoItems, ...tableItems])
    const all = [...matchItems, ...ovoItems, ...tableItems]
    const now = new Date()

    const withDate = all.filter(i => i._date)
    const withoutDate = allMatches.filter(m => !m.tee_time).map(m => ({ ...m, _type: 'match' }))

    setUpcoming(withDate.sort((a, b) => new Date(a._date) - new Date(b._date)))
    setPast([])
    setUnscheduled(withoutDate.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)))

    setLoading(false)
  }

  const fmt = (dt) => new Date(dt).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })
  const isToday = (dt) => new Date(dt).toDateString() === new Date().toDateString()
  const isTomorrow = (dt) => {
    const tom = new Date(); tom.setDate(tom.getDate() + 1)
    return new Date(dt).toDateString() === tom.toDateString()
  }
  const timeLabel = (dt) => {
    if (isToday(dt)) return '🟢 TODAY'
    if (isTomorrow(dt)) return '🟡 TOMORROW'
    return null
  }

  if (loading) return (
    <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ color: '#7A7570', fontFamily: 'DM Sans, sans-serif' }}>Loading...</div>
    </div>
  )

  const getName = (id) => profiles[id] ? `${profiles[id].first_name} ${profiles[id].last_name}` : '?'

  const ItemCard = ({ m }) => {
    const date = m._date
    return (
      <div style={s.card} onClick={() => {
        if (m._type === 'match') onOpenLobby(m.id)
        else if (m._type === 'table' && onOpenTable) onOpenTable(m.id)
      }}>
        <div style={s.cardTop}>
          <div style={s.cardLeft}>
            <div style={s.typeBadge}>
              {m._type === 'match' ? '⛳ GOLF MATCH' : m._type === '1v1' ? '⚔️ 1V1 BET' : '🎯 TABLE'}
            </div>
            <div style={s.matchName}>
              {m._type === 'match' ? (m.name || m.course_name || 'Match') :
               m._type === '1v1' ? `vs ${getName(m.created_by === session.user.id ? m.opponent_id : m.created_by)}` :
               m.name}
            </div>
            {m._type === '1v1' && <div style={s.matchCourse}>{m.description}</div>}
            {m._type === 'match' && <div style={s.matchCourse}>{m.course_name}{m.num_holes ? ` · ${m.num_holes} holes · Par ${m.course_par}` : ''}</div>}
            {date && (
              <div style={s.matchTime}>
                {timeLabel(date) && <span style={s.todayBadge}>{timeLabel(date)} · </span>}
                {fmt(date)}
              </div>
            )}
          </div>
          <div style={s.cardRight}>
            {m._type === '1v1' && <div style={s.wagerAmt}>${m.wager_amount}</div>}
            <div style={s.cardArrow}>→</div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div style={s.screen}>
      <div style={s.body}>

        {/* Upcoming */}
        <div style={s.sectionHeader}>
          <div style={s.sectionTitle}>UPCOMING</div>
          <button style={s.newBtn} onClick={onCreateMatch}>+ New</button>
        </div>

        {upcoming.length === 0 ? (
          <div style={s.emptyCard}>
            <div style={s.emptyIcon}>📅</div>
            <div style={s.emptyText}>No upcoming matches</div>
            <div style={s.emptySub}>Create a match with a tee time to see it here</div>
            <button style={s.createBtn} onClick={onCreateMatch}>Create Match →</button>
          </div>
        ) : upcoming.map(m => <ItemCard key={m.id} m={m} />)}

        {/* Unscheduled — matches without tee time */}
        {unscheduled.length > 0 && (
          <>
            <div style={s.sectionHeader}>
              <div style={s.sectionTitle}>OPEN MATCHES</div>
            </div>
            {unscheduled.map(m => <ItemCard key={m.id} m={m} />)}
          </>
        )}

        {/* Past */}
        {past.length > 0 && (
          <>
            <button style={s.pastToggle} onClick={() => setShowPast(v => !v)}>
              {showPast ? '▲' : '▼'} PAST MATCHES ({past.length})
            </button>
            {showPast && past.map(m => <ItemCard key={m.id} m={m} />)}
          </>
        )}

      </div>
    </div>
  )
}

const s = {
  screen: { display: 'flex', flexDirection: 'column', fontFamily: "'DM Sans', sans-serif", background: '#FDF9E7' },
  body: { padding: '16px 24px 48px', display: 'flex', flexDirection: 'column', gap: 10 },
  sectionHeader: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 8 },
  sectionTitle: { fontFamily: "'Outfit', sans-serif", fontWeight: 700, fontSize: 18, color: '#1A1814', letterSpacing: 1 },
  newBtn: { background: 'rgba(0,96,57,0.08)', border: '1px solid #00563F', borderRadius: 10, padding: '6px 14px', fontSize: 13, color: '#00563F', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' },
  emptyCard: { background: '#FFFFFF', borderRadius: 20, padding: 28, border: '1px solid #E0DDD4', textAlign: 'center' },
  emptyIcon: { fontSize: 32, marginBottom: 10 },
  emptyText: { fontSize: 15, fontWeight: 600, color: '#1A1814', marginBottom: 4 },
  emptySub: { fontSize: 13, color: '#7A7570', marginBottom: 16 },
  createBtn: { background: 'linear-gradient(135deg,#00563F,#006B4D)', color: 'white', border: 'none', borderRadius: 12, padding: '12px 24px', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' },
  card: { background: '#FFFFFF', borderRadius: 16, padding: '14px 16px', border: '1px solid #E0DDD4', cursor: 'pointer', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' },
  cardTop: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  cardLeft: { flex: 1 },
  matchName: { fontSize: 15, fontWeight: 700, color: '#1A1814', marginBottom: 4 },
  matchTime: { fontSize: 13, color: '#00563F', fontWeight: 600, marginBottom: 2 },
  todayBadge: { fontSize: 11, fontWeight: 700 },
  matchCourse: { fontSize: 12, color: '#7A7570' },
  cardArrow: { fontSize: 18, color: '#C19A6B', fontWeight: 700, marginLeft: 12 },
  cardRight: { display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 4, flexShrink: 0 },
  typeBadge: { fontSize: 10, fontWeight: 700, color: '#7A7570', letterSpacing: 1, marginBottom: 4 },
  wagerAmt: { fontFamily: "'Bebas Neue', sans-serif", fontSize: 18, color: '#C19A6B' },
  pastToggle: { background: 'transparent', border: 'none', color: '#7A7570', fontSize: 12, fontWeight: 700, letterSpacing: 1, cursor: 'pointer', fontFamily: 'inherit', textAlign: 'left', padding: '8px 0' },
}
